<template>
  <div class="achievement-box">
    <div class="achievement-title flex align-center">
      <i class="iconfont iconjixiaokaohezhuantibaobiao"></i>
      <span class="size14 area-tit">绩效看板</span>
    </div>
    <div class="achievement-main" v-loading="loading" v-if="hasData">
      <template v-for="row in tableData">
        <div class="achievement-item" :key="row.id">
          <div class="flex justify-between">
            <div class="shop flex align-center">
              <gj-icon v-if="getCountryFlag(row.countryCode)" :iconfont="getCountryFlag(row.countryCode)" class="gj-mr4" style="font-size: 16px;"></gj-icon>
              <span class="color666 size12">{{ row.marketId | optionText(marketOption) }}</span>
            </div>
            <div class="flex align-center" v-if="isAbnormal(row)">
              <i class="el-icon-warning colorOrange gj-mr4"></i>
              <span class="color333 size12">指标异常</span>
            </div>
          </div>
          <div class="achievement-bord flex justify-between align-center">
            <div class="achievement-quota">
              <div class="color666 size14 gj-mb4">店铺缺陷率</div>
              <div class="size22 weight600 gj-pointer gj-number" :class="row.orderWithDefectRateTarget?'':'colorRed'" @click="pushDetails('#customer-service', row.marketId, row.countryCode)">{{row.orderWithDefectRate || 0}}</div>
            </div>
            <div class="achievement-quota">
              <div class="color666 size14 gj-mb4">商品政策合规性</div>
              <div class="size22 weight600 gj-pointer gj-number" :class="row.commodityPolicyDefectTarget?'':'colorRed'" @click="pushDetails('#product-compliance', row.marketId, row.countryCode)">{{row.commodityPolicyDefect || 0}}</div>
            </div>
            <div class="achievement-quota">
              <div class="color666 size14 gj-mb4">预配送取消率</div>
              <div class="size22 weight600 gj-pointer gj-number" :class="row.preFulfillmentCancellationRateTarget?'':'colorRed'" @click="pushDetails('#distribution-performance', row.marketId, row.countryCode)">{{row.preFulfillmentCancellationRate || 0}}</div>
            </div>
            <div class="achievement-quota">
              <div class="color666 size14 gj-mb4">进货不满意率</div>
              <div class="size22 weight600 gj-pointer gj-number" :class="row.returnDissatisfactionRateTarget?'':'colorRed'" @click="pushDetails('#customer-service', row.marketId, row.countryCode)">{{row.returnDissatisfactionRate || 0}}</div>
            </div>
            <div class="achievement-quota">
              <div class="color666 size14 gj-mb4">迟发率</div>
              <div class="size22 weight600 gj-pointer gj-number" :class="row.lateShipmentRateTarget?'':'colorRed'" @click="pushDetails('#distribution-performance', row.marketId, row.countryCode)">{{row.lateShipmentRate || 0}}</div>
            </div>
            <div class="achievement-quota">
              <div class="color666 size14 gj-mb4">有效追踪率</div>
              <div class="size22 weight600 gj-pointer gj-number" :class="row.validTrackingRateTarget?'':'colorRed'" @click="pushDetails('#distribution-performance', row.marketId, row.countryCode)">{{row.validTrackingRate || 0}}</div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="achievement-main flex flex-direction-column align-center" v-if="!hasData">
      <el-image :src="noData" class="mt70"></el-image>
      <div class="size16 color333 gj-mt16">👍🏻太棒啦！！您经营的店铺指标目前无异常，继续保持住哦～</div>
      <gj-button type="text" @click="$router.push({path: '/statistics/store-performance'})" class="size16">去查看店铺绩效</gj-button>
    </div>
  </div>
</template>

<script>
import { convertToDate } from "@/utils/date.util.js"
import { optionText } from "@/filters"
import { countryOption } from "@/utils/options"
import { performance } from "@/api/statistics"
import {dashboardMixin, queryMixin} from "@/minxins";
import {mapGetters} from "vuex";
export default {
  name: "dashboard-achievement",
  mixins: [queryMixin, dashboardMixin],
  data(){
    return {
      date: new Date(),
      tableData: [],
      hasData: true,
      noData: require("@/assets/images/dashboard/achievement.png")
    }
  },
  computed:{
    ...mapGetters({
      marketOption: "marketOption",
    }),
  },
  activated() {
    this.$gjQuery()
  },
  methods: {
    // 获取数据
    async $gjQuery() {
      if(!this.showStoreMask){
        return
      }
      this.loading = true
      let params = {
        dataTime: convertToDate(this.date),
        countryCodes: this.countryMarket.countryIds,
        marketIds: this.countryMarket.marketIds,
        order: "descending",
        sort: "orderWithDefectRate"
      }
      try {
        let { dataList = [] } = await performance(params) || {}
        this.tableData = dataList.filter(item => { return this.isAbnormal(item) })
      } finally {
        this.loading = false
        this.hasData = this.tableData.length > 0
      }
    },
    // 跳转详情
    pushDetails(anchorRoll, marketId, countryCode) {
      sessionStorage.setItem("anchorRoll", anchorRoll);
      this.$router.push({
        path: "/statistics/store-performance-details",
        query: {
          marketId,
          countryCode
        }
      })
    },
    // 获取站点国旗
    getCountryFlag(countryCode) {
      return optionText(countryCode, countryOption, 'id', 'icon')
    },
    // 判断数据是否有异常
    isAbnormal(row) {
      return !row.orderWithDefectRateTarget || !row.commodityPolicyDefectTarget || !row.preFulfillmentCancellationRateTarget || !row.returnDissatisfactionRateTarget || !row.lateShipmentRateTarget || !row.validTrackingRateTarget
    }
  }
}
</script>


<style scoped lang="scss">
.achievement-box{
  background-color: #fff;
  height: 372px;
  padding: 0 16px;
  padding-right: 4px;
  border-radius: 4px;
  justify-content: space-between;
  .achievement-title{
    height: 54px;
  }
  .achievement-main {
    padding-right: 12px;
    height: 316px;
    overflow-y: auto;
  }
  .achievement-item{
    height: 104px;
    border-bottom: 1px solid #E4E5E6;
    margin-bottom: 16px;
    .shop {
      padding: 2px 12px;
      background: #F6F8FB;
      border-radius: 2px;
    }
    .achievement-bord {
      height: 80px;
    }
    .achievement-quota {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 56px;
    }
  }
  .mt70 {
    margin-top: 70px;
  }
  .gj-number {
  font-family: DINAlternate-Bold;
  font-weight: 700;
}
}
</style>